export default __webpack_public_path__ + "static/media/pantry1-afterD-768w.c27e1f6a.png";